// extracted by mini-css-extract-plugin
export default {"sherpa":"Sherpa_sherpa__Gfcc6"};